/* @flow */
import { ERRORS } from 'lib/RemindAPI';
import { mountModal } from 'lib/modal';
import ActivityAgeConfirmationModal from './ActivityAgeConfirmationModal.jsx';
import ActivityRecipient from 'entities/ActivityRecipient';
import Chat from 'entities/Chat';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import CurrentUser from 'auth/CurrentUser';
import cx from 'classnames';
import EventParticipationForm from './EventParticipationForm.jsx';
import EventTrackingConstants from '../constants/EventTrackingConstants';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import Activity, { ATTENDANCE } from 'entities/Activity';
import React, { PropTypes } from 'react';
import ToastActions from 'actions/ToastActions';

import styles from './styles/EventParticipationView.scss';

function leaveChatConfirmationDialog(onConfirm: Function, onCancel: Function) {
  return (
    <ConfirmDialog
      eventScreenName="EventParticipationView"
      title={'Would you like to leave the conversation related to this Activity?'}
      actionButtonText="Yes"
      cancelButtonText="No"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}

const EventParticipationView = React.createClass({
  propTypes: {
    initialRSVP: PropTypes.oneOf([ATTENDANCE.YES, ATTENDANCE.NO, ATTENDANCE.MAYBE]),
    activity: PropTypes.instanceOf(Activity).isRequired,
    editableEventRecipient: PropTypes.instanceOf(ActivityRecipient),
    onRecipientCreated: PropTypes.func.isRequired,
  },

  childContextTypes: {
    eventScreenName: PropTypes.string,
  },

  mixins: [
    linkStateWithStores([CurrentUser]),
  ],

  getInitialState() {
    return {
      processingSubmit: false,
      ...this.getStateFromStores(),
    };
  },

  getChildContext() {
    return {
      eventScreenName: EventTrackingConstants.RSVP,
    };
  },

  onDone() {
    if (this.isMounted()) {
      this.setState({ processingSubmit: false });
    }
  },

  onRSVPCreated(recipient: ActivityRecipient, contribute: boolean, attendance: string) {
    const chatUuid: ?string = this.props.activity.getChatUuid();
    const isSender: boolean = this.props.activity.isSender();

    const onDone: Function = () => {
      this.props.onRecipientCreated(recipient, contribute);
      this.onDone();
    };

    if (!isSender && this.state.user && chatUuid && attendance === ATTENDANCE.NO) {
      // if the activity has a group chat and the current logged in user RSVP no,
      // then we check if the user is part of the group chat. If he is then we ask
      // him if he wants to leave, otherwise resume normal flow.
      Chat.fetch({ uuid: chatUuid }).then((chat: Chat) => {
        // if user already left, we can abort!
        if (!chat.isPresent()) {
          onDone();
          return;
        }

        // otherwise ask for confirmation
        const confirmationModal = (
          leaveChatConfirmationDialog(() => {
            chat.leave().then(onDone, onDone);
          }, onDone)
        );

        mountModal(confirmationModal, this);
      }, onDone);
    } else {
      onDone();
    }
  },

  onValidSubmit(values: Object) {
    const onRSVPCreated: Function = recipient => {
      return this.onRSVPCreated(recipient, values.contribute, values.response);
    };

    const onAgeConfirmed: Function = (confirmedIsChild, confirmedBirthdate) => {
      return this.submitForm(values, confirmedIsChild, confirmedBirthdate).then(onRSVPCreated);
    };

    this.setState({ processingSubmit: true });
    this.submitForm(values).then(onRSVPCreated, error => {
      if (error) {
        switch (error.code) {
          case ERRORS.birthdate_required:
            mountModal(<ActivityAgeConfirmationModal onAgeConfirmed={onAgeConfirmed} />, this);
            break;
          default:
            this.setState({ processingSubmit: false });
            ToastActions.showAPIError(error);
            break;
        }
      }
    });
  },

  getStateFromStores() {
    return {
      user: CurrentUser.isSignedIn() ? CurrentUser.getUser() : null,
    };
  },

  submitForm(values: Object, isChild: ?boolean, birthdate: ?Date) {
    const { activity } = this.props;
    const { note, response, name, address } = values;
    let opts = { note, attendance: response };
    const { user } = this.state;

    if (!user) {
      opts = { ...opts, name, address };
    }

    if (activity.hasChildren()) {
      const child = user ? user.getIsChild() : isChild;

      opts = { ...opts, is_child: child };

      if (!user && isChild) {
        opts = { ...opts, birthdate };
      }
    } else {
      opts = { ...opts, is_child: false };
    }

    return this.props.activity.createRSVP(opts);
  },

  render() {
    const { activity } = this.props;

    return (
      <div className={cx(styles.this, this.props.className)}>
        <EventParticipationForm
          initialRSVP={this.props.initialRSVP}
          isCollectingMoney={activity.isCollectingMoneyOnline()}
          onValidSubmit={this.onValidSubmit}
          editableEventRecipient={this.props.editableEventRecipient}
          processingSubmit={this.state.processingSubmit}
          showParticipantIdentityFields={!this.state.user}
          eventScreenName={EventTrackingConstants.RSVP}
        />
      </div>
    );
  },
});

export default EventParticipationView;



// WEBPACK FOOTER //
// ./src/payments/components/EventParticipationView.jsx